export const getColor = (classification, colors) => {
  switch (classification) {
    case 'SATIVA':
      return colors.sativaColor;
    case 'S/I':
      return colors.siColor;
    case 'HYBRID':
      return colors.hybridColor;
    case 'I/S':
      return colors.isColor;
    case 'INDICA':
      return colors.indicaColor;
    case 'CBD':
      return colors.cbdColor;
    case 'KUSH':
      return colors.kushColor;
    default:
      return '#000';
  }
};

export const getStyle = (classificationName, colors) => {
  const bg = getColor(classificationName, colors);
  return {
    border: `1px solid #${bg}`,
    background: `#${bg}`,
    color: '#FFF',
  };
};



// WEBPACK FOOTER //
// ./src/helpers/classification_util.js